export default {"src":"/_next/static/media/external_regular.0b2ec54c.svg","height":24,"width":24};